import { Component } from '@angular/core';
import { AuthService } from '../_services/auth.service';
import { MatButton } from '@angular/material/button';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.css'],
  imports: [MatButton]
})
export class SupportComponent {
  errorMessage: string | null = null;
  signingIn = false;

  constructor(private auth: AuthService) {}

  async signInWithMicrosoft(): Promise<void> {
    this.signingIn = true;
    this.errorMessage = null;

    const message = await this.auth.supportLoginWithMicrosoft();

    this.signingIn = false;
    if (message) {
      this.errorMessage = message;
    }
  }
}
